import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 25, message: 'Maximum number of  reached' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 25, message: 'Maximum number of  reached' }
      ]
    },
    clientName: {
      validations: [
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of  reached' }
      ]
    },
    addressLine1: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of  reached' }
      ]
    },
    city: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 30, message: 'Maximum number of  reached' }
      ]
    },
    state: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 30, message: 'Maximum number of  reached' }
      ]
    },
    postal: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 15, message: 'Maximum number of  reached' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 30, message: 'Maximum number of  reached' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of  reached' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of  reached' }
      ]
    },
    eventExtra1: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of  reached' }
      ]
    },
    eventExtra2: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of  reached' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    siteName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of  reached' }
      ]
    },    
    plannedGuestCount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'maxLength', maxLength: 10, message: 'Maximum number of  reached' }
      ]
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Business Name',
            mapping: 'clientName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address *',
            mapping: 'addressLine1'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City *',
            mapping: 'city'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State *',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'state'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip *',
            mapping: 'postal'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone *',
            mapping: 'telNumber'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Event *',
            options: [
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Corporate', value: 'Corporate' },
              { label: 'Personal', value: 'Personal' }
            ],
            mapping: 'theme'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Service *',
            options: [
              { label: 'Bar Catering', value: 'Bar Catering' },
              { label: 'Delivery', value: 'Delivery' },
              { label: 'Store Pick-up', value: 'Store Pick-Up' },
            ],
            mapping: 'eventExtra1'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Rental items interested in',
            options: [
              { label: 'Tapper', value: 'Tapper' },
              { label: 'Kegerator', value: 'Kegerator' },
              { label: 'Trailer', value: 'Trailer' },
            ],
            mapping: 'eventExtra2'
          },
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date *',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Venue (please include city) *',
            mapping: 'siteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Estimated no. of guests: *',
            mapping: 'plannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Any additional information',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Gerczak\'s Liquor & Catering Request a Quote',
    formId: '1870',
    clientKey: 'C16DBCE1-7470-498D-8A8F-81DA491CDC7C',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you for your submission. We\'ll get back to you before the end of the next business day. Kim Agostine - Owner - Gerczak\'s Liquor & Beverage Catering',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
